var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgConfetti = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200px",
    height: "110px",
    viewBox: "0 0 1200 110",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 25") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Custom-Courses",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(14.9098, 5)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F2CADD",
    points: "432.549073 8.4096024 428.090227 20.5701425 431.87349 22.3255814 436.339843 11.1102776"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E6F1F2",
    cx: 442.149856,
    cy: 48.5446362,
    rx: 8.39974626,
    ry: 8.39459865
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F3BD67",
    points: "429.704119 67.6444111 442.382556 79.0847712 445.392653 76.6991748 432.40645 64.8462116"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F9DDAC",
    opacity: 0.43,
    cx: 540.019285,
    cy: 68.9272318,
    rx: 8.39974626,
    ry: 8.39459865
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-2",
    fill: "#F9DDAC",
    opacity: 0.43,
    cx: 911.019285,
    cy: 57.9272318,
    rx: 8.39974626,
    ry: 8.39459865
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy",
    fill: "#F9DDAC",
    opacity: 0.43,
    transform: "translate(587.7725, 22.1905) rotate(-180) translate(-587.7725, -22.1905)",
    cx: 587.772523,
    cy: 22.1905476,
    rx: 8.39974626,
    ry: 8.39459865
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy-4",
    fill: "#828BA7",
    transform: "translate(594.1906, 46.3316) rotate(-180) translate(-594.1906, -46.3316)",
    points: "586.706604 43.1057764 598.76951 52.9032258 601.674516 49.9624906 590.212128 39.75994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.933437,63.2633158 C589.876662,63.6084021 585.440335,64.5986497 581.521955,67.7194299 C578.046457,70.4876219 576.672772,73.6009002 576.117292,75.2138035 L580.666217,77.3218305 C580.951463,76.4666167 581.341799,75.5813953 581.874759,74.6886722 C585.019972,69.4823706 591.220321,67.3593398 594.230418,66.5491373 L591.933437,63.255814 L591.933437,63.2633158 Z",
    id: "Path-Copy-5",
    fill: "#83B2BD",
    transform: "translate(585.1739, 70.2888) rotate(-180) translate(-585.1739, -70.2888)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy",
    fill: "#F9DDAC",
    opacity: 0.43,
    transform: "translate(958.7725, 22.1905) rotate(-180) translate(-958.7725, -22.1905)",
    cx: 958.772523,
    cy: 22.1905476,
    rx: 8.39974626,
    ry: 8.39459865
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy-4",
    fill: "#828BA7",
    transform: "translate(965.1906, 46.3316) rotate(-180) translate(-965.1906, -46.3316)",
    points: "957.706604 43.1057764 969.76951 52.9032258 972.674516 49.9624906 961.212128 39.75994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.933437,63.2633158 C960.876662,63.6084021 956.440335,64.5986497 952.521955,67.7194299 C949.046457,70.4876219 947.672772,73.6009002 947.117292,75.2138035 L951.666217,77.3218305 C951.951463,76.4666167 952.341799,75.5813953 952.874759,74.6886722 C956.019972,69.4823706 962.220321,67.3593398 965.230418,66.5491373 L962.933437,63.255814 L962.933437,63.2633158 Z",
    id: "Path-Copy-5",
    fill: "#83B2BD",
    transform: "translate(956.1739, 70.2888) rotate(-180) translate(-956.1739, -70.2888)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EBECEB",
    points: "498.523488 38.0270068 516.816769 29.4898725 511.344548 24.6511628 496.436688 33.5858965"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C39E93",
    points: "568.131037 45.0712678 556.293324 39.7899475 554.281589 43.4433608 565.173485 48.6571643"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy-6",
    fill: "#C39E93",
    points: "939.131037 45.0712678 927.293324 39.7899475 925.281589 43.4433608 936.173485 48.6571643"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F9DDAC",
    points: "560.279263 82.9182296 570.090227 69.3698425 564.175124 68.0645161 556.976414 80.540135"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy-7",
    fill: "#F9DDAC",
    points: "925.279263 82.9182296 935.090227 69.3698425 929.175124 68.0645161 921.976414 80.540135"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F9DDAC",
    points: "516.073628 68.0420105 511.367068 55.9714929 507.366116 57.1567892 511.442132 68.5221305"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#828BA7",
    points: "526.117292 41.5603901 538.180199 51.3578395 541.085205 48.4171043 529.622816 38.2145536"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy-8",
    fill: "#828BA7",
    points: "897.117292 86.5603901 909.180199 96.3578395 912.085205 93.4171043 900.622816 83.2145536"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#83B2BD",
    cx: 463.565831,
    cy: 18.7996999,
    rx: 3.89586087,
    ry: 3.89347337
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.696031,52.108027 C467.018809,50.6526632 467.536756,47.3968492 466.313201,43.5783946 C465.224762,40.1875469 463.295598,37.9969992 462.244691,36.9542386 L459.377217,38.9647412 C459.932696,39.5048762 460.488176,40.1350338 460.998616,40.8552138 C464.001206,45.0637659 463.828557,49.9174794 463.580844,52.1830458 L466.688525,52.108027 L466.696031,52.108027 Z",
    id: "Path",
    fill: "#CADAEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.377534,13.8034509 C553.32076,14.1485371 548.884433,15.1387847 544.966053,18.2595649 C541.490554,21.0277569 540.116869,24.1410353 539.56139,25.7539385 L544.110314,27.8619655 C544.395561,27.0067517 544.785897,26.1215304 545.318857,25.2288072 C548.46407,20.0225056 554.664419,17.8994749 557.674516,17.0892723 L555.377534,13.795949 L555.377534,13.8034509 Z",
    id: "Path",
    fill: "#83B2BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.377534,13.8034509 C924.32076,14.1485371 919.884433,15.1387847 915.966053,18.2595649 C912.490554,21.0277569 911.116869,24.1410353 910.56139,25.7539385 L915.110314,27.8619655 C915.395561,27.0067517 915.785897,26.1215304 916.318857,25.2288072 C919.46407,20.0225056 925.664419,17.8994749 928.674516,17.0892723 L926.377534,13.795949 L926.377534,13.8034509 Z",
    id: "Path-Copy-9",
    fill: "#83B2BD"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#ABB8D5",
    points: "488.975251 63.2483121 476.109151 64.8537134 476.2818 69.0172543 488.299668 67.8469617"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FCEACE",
    opacity: 0.46,
    cx: 494.950405,
    cy: 8.39459865,
    rx: 8.39974626,
    ry: 8.39459865
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F3BD67",
    cx: 467.409146,
    cy: 89.3248312,
    rx: 10.6817149,
    ry: 10.6751688
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F2CADD",
    transform: "translate(813.215, 84.6324) scale(-1, 1) rotate(-180) translate(-813.215, -84.6324)",
    points: "813.549073 77.6744186 809.090227 89.8349587 812.87349 91.5903976 817.339843 80.3750938"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E6F1F2",
    transform: "translate(886.1499, 16.4554) scale(-1, 1) rotate(-180) translate(-886.1499, -16.4554)",
    cx: 886.149856,
    cy: 16.4553638,
    rx: 8.39974626,
    ry: 8.39459865
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F3BD67",
    transform: "translate(818.5484, 28.0345) scale(-1, 1) rotate(-180) translate(-818.5484, -28.0345)",
    points: "810.704119 23.7134284 823.382556 35.1537884 826.392653 32.768192 813.40645 20.9152288"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F9DDAC",
    opacity: 0.43,
    transform: "translate(844.0193, 14.0728) scale(-1, 1) rotate(-180) translate(-844.0193, -14.0728)",
    cx: 844.019285,
    cy: 14.0727682,
    rx: 8.39974626,
    ry: 8.39459865
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EBECEB",
    transform: "translate(891.6267, 68.6609) scale(-1, 1) rotate(-180) translate(-891.6267, -68.6609)",
    points: "883.523488 75.3488372 901.816769 66.8117029 896.344548 61.9729932 881.436688 70.9077269"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F9DDAC",
    transform: "translate(896.7199, 37.7532) scale(-1, 1) rotate(-180) translate(-896.7199, -37.7532)",
    points: "901.073628 43.5483871 896.367068 31.4778695 892.366116 32.6631658 896.442132 44.0285071"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#83B2BD",
    transform: "translate(844.5658, 81.2003) scale(-1, 1) rotate(-180) translate(-844.5658, -81.2003)",
    cx: 844.565831,
    cy: 81.2003001,
    rx: 3.89586087,
    ry: 3.89347337
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.696031,62.9707427 C852.018809,61.5153788 852.536756,58.2595649 851.313201,54.4411103 C850.224762,51.0502626 848.295598,48.8597149 847.244691,47.8169542 L844.377217,49.8274569 C844.932696,50.3675919 845.488176,50.9977494 845.998616,51.7179295 C849.001206,55.9264816 848.828557,60.780195 848.580844,63.0457614 L851.688525,62.9707427 L851.696031,62.9707427 Z",
    id: "Path",
    fill: "#CADAEE",
    transform: "translate(848.2314, 55.4314) scale(-1, 1) rotate(-180) translate(-848.2314, -55.4314)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#ABB8D5",
    transform: "translate(863.5422, 33.8672) scale(-1, 1) rotate(-180) translate(-863.5422, -33.8672)",
    points: "869.975251 30.9827457 857.109151 32.588147 857.2818 36.7516879 869.299668 35.5813953"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FCEACE",
    opacity: 0.46,
    transform: "translate(875.9504, 91.6054) scale(-1, 1) rotate(-180) translate(-875.9504, -91.6054)",
    cx: 875.950405,
    cy: 91.6054014,
    rx: 8.39974626,
    ry: 8.39459865
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F3BD67",
    transform: "translate(817.4091, 52.6752) scale(-1, 1) rotate(-180) translate(-817.4091, -52.6752)",
    cx: 817.409146,
    cy: 52.6751688,
    rx: 10.6817149,
    ry: 10.6751688
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F3BD67",
    cx: 157.489773,
    cy: 43.5285714,
    rx: 8.3995466,
    ry: 8.43690476
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EBECEB",
    points: "204.929572 2.1281746 205.417481 22.402381 212.045542 19.3186508 209.83869 2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy",
    fill: "#EBECEB",
    transform: "translate(133.4876, 67.5877) scale(-1, -1) translate(-133.4876, -67.5877)",
    points: "129.929572 57.5146825 130.417481 77.7888889 137.045542 74.7051587 134.83869 57.3865079"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy-2",
    fill: "#F9DDAC",
    transform: "translate(142.5101, 7.1798) scale(-1, -1) translate(-142.5101, -7.1798)",
    points: "147.501814 2 136.317431 8.58214286 138.118942 12.3595238 148.702821 6.51626984"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.422469,26.8357143 C126.379093,27.9138889 124.239798,30.4321429 123.278992,34.3376984 C122.423275,37.8134921 122.926196,40.7087302 123.278992,42.1563492 L126.776927,41.9376984 C126.581763,41.1761905 126.439144,40.3543651 126.379093,39.4646825 C126.026297,34.277381 128.721058,30.2134921 130.117229,28.4039683 L127.429975,26.8281746 L127.422469,26.8357143 Z",
    id: "Path-Copy-3",
    fill: "#CADAEE",
    transform: "translate(126.4624, 34.4923) scale(-1, -1) translate(-126.4624, -34.4923)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#83B2BD",
    cx: 283.648111,
    cy: 71.5007937,
    rx: 8.3995466,
    ry: 8.43690476
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F3BD67",
    points: "177.936927 70.5583333 188.333149 84.1825397 191.725995 82.3654762 181.104584 68.2888889"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F9DDAC",
    points: "222.501814 67.4293651 211.317431 74.0115079 213.118942 77.7888889 223.702821 71.9456349"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C39E93",
    points: "296.889219 14.0861111 285.704836 20.668254 287.506348 24.4456349 298.090227 18.602381"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BFDAE0",
    points: "286.410428 70.9654762 275.976675 63.2373016 273.22937 66.3964286 282.754861 73.8531746"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#828BA7",
    points: "229.572746 44.4634921 244.315113 49.3944444 245.996524 45.6019841 231.667003 40.0753968"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E5EAF7",
    cx: 246.184181,
    cy: 63.893254,
    rx: 3.89576826,
    ry: 3.91309524
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F2CADD",
    points: "157.234559 15.5865079 169.47733 19.8539683 171.166247 16.0238095 159.86927 11.7412698"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.422469,37.6400794 C201.379093,38.718254 199.239798,41.2365079 198.278992,45.1420635 C197.423275,48.6178571 197.926196,51.5130952 198.278992,52.9607143 L201.776927,52.7420635 C201.581763,51.9805556 201.439144,51.1587302 201.379093,50.2690476 C201.026297,45.081746 203.721058,41.0178571 205.117229,39.2083333 L202.429975,37.6325397 L202.422469,37.6400794 Z",
    id: "Path",
    fill: "#CADAEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.297733,22.4551587 C267.55461,21.022619 265.79063,18.0142857 262.750579,16.3253968 C260.048312,14.825 257.646297,15.0813492 256.437783,15.3452381 L256.175063,19.7484127 C256.813098,19.6051587 257.496171,19.5297619 258.216776,19.5674603 C262.450327,19.7785714 265.400302,23.6539683 266.683879,25.6293651 L268.290227,22.4626984 L268.297733,22.4551587 Z",
    id: "Path",
    fill: "#83B2BD"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F9DDAC",
    opacity: 0.43,
    cx: 276.81738,
    cy: 44.297619,
    rx: 5.81738035,
    ry: 5.84325397
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#BFDAE0",
    opacity: 0.46,
    cx: 163.569874,
    cy: 88.5630952,
    rx: 8.3995466,
    ry: 8.43690476
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F3BD67",
    transform: "translate(1128.4081, 55.4714) rotate(-180) translate(-1128.4081, -55.4714)",
    cx: 1128.40807,
    cy: 55.4714286,
    rx: 8.3995466,
    ry: 8.43690476
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EBECEB",
    transform: "translate(1077.4103, 86.7988) rotate(-180) translate(-1077.4103, -86.7988)",
    points: "1073.8523 76.7257937 1074.34021 97 1080.96827 93.9162698 1078.76142 76.597619"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy",
    fill: "#EBECEB",
    transform: "translate(1152.4103, 31.4123) scale(-1, -1) rotate(180) translate(-1152.4103, -31.4123)",
    points: "1148.8523 21.3392857 1149.34021 41.6134921 1155.96827 38.5297619 1153.76142 21.2111111"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy-2",
    fill: "#F9DDAC",
    transform: "translate(1143.3877, 91.8202) scale(-1, -1) rotate(180) translate(-1143.3877, -91.8202)",
    points: "1148.3794 86.6404762 1137.19502 93.222619 1138.99653 97 1149.58041 91.156746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160.39547,56.8511905 C1159.35209,57.9293651 1157.2128,60.447619 1156.25199,64.3531746 C1155.39627,67.8289683 1155.89919,70.7242063 1156.25199,72.1718254 L1159.74992,71.9531746 C1159.55476,71.1916667 1159.41214,70.3698413 1159.35209,69.4801587 C1158.99929,64.2928571 1161.69406,60.2289683 1163.09023,58.4194444 L1160.40297,56.8436508 L1160.39547,56.8511905 Z",
    id: "Path-Copy-3",
    fill: "#CADAEE",
    transform: "translate(1159.4354, 64.5077) scale(-1, -1) rotate(180) translate(-1159.4354, -64.5077)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#83B2BD",
    transform: "translate(1002.2497, 27.4992) rotate(-180) translate(-1002.2497, -27.4992)",
    cx: 1002.24973,
    cy: 27.4992063,
    rx: 8.3995466,
    ry: 8.43690476
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F3BD67",
    transform: "translate(1101.0664, 22.7643) rotate(-180) translate(-1101.0664, -22.7643)",
    points: "1094.17184 17.0869048 1104.56807 30.7111111 1107.96091 28.8940476 1097.3395 14.8174603"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F9DDAC",
    transform: "translate(1068.3877, 26.3909) rotate(-180) translate(-1068.3877, -26.3909)",
    points: "1073.3794 21.2111111 1062.19502 27.793254 1063.99653 31.5706349 1074.58041 25.727381"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C39E93",
    transform: "translate(994.0003, 79.7341) rotate(-180) translate(-994.0003, -79.7341)",
    points: "998.991996 74.5543651 987.807613 81.1365079 989.609124 84.9138889 1000.193 79.0706349"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BFDAE0",
    transform: "translate(1006.0779, 30.4548) rotate(-180) translate(-1006.0779, -30.4548)",
    points: "1012.66847 32.875 1002.23472 25.1468254 999.487412 28.3059524 1009.0129 35.7626984"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#828BA7",
    transform: "translate(1048.1132, 54.2651) rotate(-180) translate(-1048.1132, -54.2651)",
    points: "1039.90132 53.9936508 1054.64368 58.9246032 1056.32509 55.1321429 1041.99557 49.6055556"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E5EAF7",
    transform: "translate(1039.7137, 35.1067) rotate(-180) translate(-1039.7137, -35.1067)",
    cx: 1039.71366,
    cy: 35.106746,
    rx: 3.89576826,
    ry: 3.91309524
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-8",
    fill: "#E5EAF7",
    transform: "translate(1166.7137, 16.1067) rotate(-180) translate(-1166.7137, -16.1067)",
    cx: 1166.71366,
    cy: 16.106746,
    rx: 3.89576826,
    ry: 3.91309524
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F2CADD",
    transform: "translate(1121.6974, 83.2024) rotate(-180) translate(-1121.6974, -83.2024)",
    points: "1114.73159 82.9912698 1126.97436 87.2587302 1128.66328 83.4285714 1117.3663 79.1460317"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085.39547,46.0468254 C1084.35209,47.125 1082.2128,49.643254 1081.25199,53.5488095 C1080.39627,57.0246032 1080.89919,59.9198413 1081.25199,61.3674603 L1084.74992,61.1488095 C1084.55476,60.3873016 1084.41214,59.5654762 1084.35209,58.6757937 C1083.99929,53.4884921 1086.69406,49.4246032 1088.09023,47.6150794 L1085.40297,46.0392857 L1085.39547,46.0468254 Z",
    id: "Path",
    fill: "#CADAEE",
    transform: "translate(1084.4354, 53.7034) rotate(-180) translate(-1084.4354, -53.7034)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.72278,80.6821748 C1028.97965,79.2496351 1027.21567,76.2413018 1024.17562,74.5524129 C1021.47336,73.052016 1019.07134,73.3083653 1017.86283,73.5722541 L1017.60011,77.9754287 C1018.23814,77.8321748 1018.92122,77.756778 1019.64182,77.7944764 C1023.87537,78.0055875 1026.82535,81.8809843 1028.10892,83.8563811 L1029.71527,80.6897145 L1029.72278,80.6821748 Z",
    id: "Path",
    fill: "#83B2BD",
    transform: "translate(1023.6614, 78.6135) rotate(-180) translate(-1023.6614, -78.6135)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F9DDAC",
    opacity: 0.43,
    transform: "translate(1009.0805, 54.7024) rotate(-180) translate(-1009.0805, -54.7024)",
    cx: 1009.08046,
    cy: 54.702381,
    rx: 5.81738035,
    ry: 5.84325397
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#BFDAE0",
    opacity: 0.46,
    transform: "translate(1122.328, 10.4369) rotate(-180) translate(-1122.328, -10.4369)",
    cx: 1122.32797,
    cy: 10.4369048,
    rx: 8.3995466,
    ry: 8.43690476
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F3BD67",
    cx: 651.489773,
    cy: 43.5285714,
    rx: 8.3995466,
    ry: 8.43690476
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EBECEB",
    points: "698.929572 2.1281746 699.417481 22.402381 706.045542 19.3186508 703.83869 2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy",
    fill: "#EBECEB",
    transform: "translate(627.4876, 67.5877) scale(-1, -1) translate(-627.4876, -67.5877)",
    points: "623.929572 57.5146825 624.417481 77.7888889 631.045542 74.7051587 628.83869 57.3865079"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy-2",
    fill: "#F9DDAC",
    transform: "translate(636.5101, 7.1798) scale(-1, -1) translate(-636.5101, -7.1798)",
    points: "641.501814 2 630.317431 8.58214286 632.118942 12.3595238 642.702821 6.51626984"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.422469,26.8357143 C620.379093,27.9138889 618.239798,30.4321429 617.278992,34.3376984 C616.423275,37.8134921 616.926196,40.7087302 617.278992,42.1563492 L620.776927,41.9376984 C620.581763,41.1761905 620.439144,40.3543651 620.379093,39.4646825 C620.026297,34.277381 622.721058,30.2134921 624.117229,28.4039683 L621.429975,26.8281746 L621.422469,26.8357143 Z",
    id: "Path-Copy-3",
    fill: "#CADAEE",
    transform: "translate(620.4624, 34.4923) scale(-1, -1) translate(-620.4624, -34.4923)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#83B2BD",
    cx: 777.648111,
    cy: 71.5007937,
    rx: 8.3995466,
    ry: 8.43690476
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F3BD67",
    points: "671.936927 70.5583333 682.333149 84.1825397 685.725995 82.3654762 675.104584 68.2888889"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F9DDAC",
    points: "716.501814 67.4293651 705.317431 74.0115079 707.118942 77.7888889 717.702821 71.9456349"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C39E93",
    points: "790.889219 14.0861111 779.704836 20.668254 781.506348 24.4456349 792.090227 18.602381"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BFDAE0",
    points: "780.410428 70.9654762 769.976675 63.2373016 767.22937 66.3964286 776.754861 73.8531746"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#828BA7",
    points: "723.572746 44.4634921 738.315113 49.3944444 739.996524 45.6019841 725.667003 40.0753968"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E5EAF7",
    cx: 740.184181,
    cy: 63.893254,
    rx: 3.89576826,
    ry: 3.91309524
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F2CADD",
    points: "651.234559 15.5865079 663.47733 19.8539683 665.166247 16.0238095 653.86927 11.7412698"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.422469,37.6400794 C695.379093,38.718254 693.239798,41.2365079 692.278992,45.1420635 C691.423275,48.6178571 691.926196,51.5130952 692.278992,52.9607143 L695.776927,52.7420635 C695.581763,51.9805556 695.439144,51.1587302 695.379093,50.2690476 C695.026297,45.081746 697.721058,41.0178571 699.117229,39.2083333 L696.429975,37.6325397 L696.422469,37.6400794 Z",
    id: "Path",
    fill: "#CADAEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.297733,22.4551587 C761.55461,21.022619 759.79063,18.0142857 756.750579,16.3253968 C754.048312,14.825 751.646297,15.0813492 750.437783,15.3452381 L750.175063,19.7484127 C750.813098,19.6051587 751.496171,19.5297619 752.216776,19.5674603 C756.450327,19.7785714 759.400302,23.6539683 760.683879,25.6293651 L762.290227,22.4626984 L762.297733,22.4551587 Z",
    id: "Path",
    fill: "#83B2BD"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F9DDAC",
    opacity: 0.43,
    cx: 770.81738,
    cy: 44.297619,
    rx: 5.81738035,
    ry: 5.84325397
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#BFDAE0",
    opacity: 0.46,
    cx: 657.569874,
    cy: 88.5630952,
    rx: 8.3995466,
    ry: 8.43690476
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EBECEB",
    transform: "translate(18.4876, 86.7988) scale(-1, 1) rotate(-180) translate(-18.4876, -86.7988)",
    points: "14.9295718 76.7257937 15.4174811 97 22.0455416 93.9162698 19.8386902 76.597619"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#83B2BD",
    transform: "translate(93.6481, 27.4992) scale(-1, 1) rotate(-180) translate(-93.6481, -27.4992)",
    cx: 93.6481108,
    cy: 27.4992063,
    rx: 8.3995466,
    ry: 8.43690476
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F9DDAC",
    transform: "translate(27.5101, 26.3909) scale(-1, 1) rotate(-180) translate(-27.5101, -26.3909)",
    points: "32.5018136 21.2111111 21.3174307 27.793254 23.1189421 31.5706349 33.7028212 25.727381"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C39E93",
    transform: "translate(101.8975, 79.7341) scale(-1, 1) rotate(-180) translate(-101.8975, -79.7341)",
    points: "106.889219 74.5543651 95.7048363 81.1365079 97.5063476 84.9138889 108.090227 79.0706349"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BFDAE0",
    transform: "translate(89.8199, 30.4548) scale(-1, 1) rotate(-180) translate(-89.8199, -30.4548)",
    points: "96.4104282 32.875 85.9766751 25.1468254 83.2293703 28.3059524 92.7548615 35.7626984"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#828BA7",
    transform: "translate(47.7846, 54.2651) scale(-1, 1) rotate(-180) translate(-47.7846, -54.2651)",
    points: "39.5727456 53.9936508 54.3151134 58.9246032 55.9965239 55.1321429 41.6670025 49.6055556"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E5EAF7",
    transform: "translate(56.1842, 35.1067) scale(-1, 1) rotate(-180) translate(-56.1842, -35.1067)",
    cx: 56.1841814,
    cy: 35.106746,
    rx: 3.89576826,
    ry: 3.91309524
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4224685,46.0468254 C11.3790932,47.125 9.23979849,49.643254 8.27899244,53.5488095 C7.42327456,57.0246032 7.92619647,59.9198413 8.27899244,61.3674603 L11.776927,61.1488095 C11.5817632,60.3873016 11.4391436,59.5654762 11.3790932,58.6757937 C11.0262972,53.4884921 13.7210579,49.4246032 15.1172292,47.6150794 L12.4299748,46.0392857 L12.4224685,46.0468254 Z",
    id: "Path",
    fill: "#CADAEE",
    transform: "translate(11.4624, 53.7034) scale(-1, 1) rotate(-180) translate(-11.4624, -53.7034)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.297733,80.6821748 C77.5546096,79.2496351 75.7906297,76.2413018 72.7505793,74.5524129 C70.0483123,73.052016 67.6462972,73.3083653 66.4377834,73.5722541 L66.175063,77.9754287 C66.8130982,77.8321748 67.4961713,77.756778 68.2167758,77.7944764 C72.4503275,78.0055875 75.4003023,81.8809843 76.6838791,83.8563811 L78.2902267,80.6897145 L78.297733,80.6821748 Z",
    id: "Path",
    fill: "#83B2BD",
    transform: "translate(72.2364, 78.6135) scale(-1, 1) rotate(-180) translate(-72.2364, -78.6135)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F9DDAC",
    opacity: 0.43,
    transform: "translate(86.8174, 54.7024) scale(-1, 1) rotate(-180) translate(-86.8174, -54.7024)",
    cx: 86.8173804,
    cy: 54.702381,
    rx: 5.81738035,
    ry: 5.84325397
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-7",
    fill: "#F9DDAC",
    opacity: 0.43,
    transform: "translate(5.8174, 19.7024) scale(-1, 1) rotate(-180) translate(-5.8174, -19.7024)",
    cx: 5.81738035,
    cy: 19.702381,
    rx: 5.81738035,
    ry: 5.84325397
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#BFDAE0",
    opacity: 0.46,
    transform: "translate(43.5699, 10.4369) scale(-1, 1) rotate(-180) translate(-43.5699, -10.4369)",
    cx: 43.5698741,
    cy: 10.4369048,
    rx: 8.3995466,
    ry: 8.43690476
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EBECEB",
    transform: "translate(323.4876, 86.7988) scale(-1, 1) rotate(-180) translate(-323.4876, -86.7988)",
    points: "319.929572 76.7257937 320.417481 97 327.045542 93.9162698 324.83869 76.597619"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#83B2BD",
    transform: "translate(398.6481, 27.4992) scale(-1, 1) rotate(-180) translate(-398.6481, -27.4992)",
    cx: 398.648111,
    cy: 27.4992063,
    rx: 8.3995466,
    ry: 8.43690476
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F9DDAC",
    transform: "translate(332.5101, 26.3909) scale(-1, 1) rotate(-180) translate(-332.5101, -26.3909)",
    points: "337.501814 21.2111111 326.317431 27.793254 328.118942 31.5706349 338.702821 25.727381"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C39E93",
    transform: "translate(406.8975, 79.7341) scale(-1, 1) rotate(-180) translate(-406.8975, -79.7341)",
    points: "411.889219 74.5543651 400.704836 81.1365079 402.506348 84.9138889 413.090227 79.0706349"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BFDAE0",
    transform: "translate(394.8199, 30.4548) scale(-1, 1) rotate(-180) translate(-394.8199, -30.4548)",
    points: "401.410428 32.875 390.976675 25.1468254 388.22937 28.3059524 397.754861 35.7626984"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#828BA7",
    transform: "translate(352.7846, 54.2651) scale(-1, 1) rotate(-180) translate(-352.7846, -54.2651)",
    points: "344.572746 53.9936508 359.315113 58.9246032 360.996524 55.1321429 346.667003 49.6055556"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E5EAF7",
    transform: "translate(361.1842, 35.1067) scale(-1, 1) rotate(-180) translate(-361.1842, -35.1067)",
    cx: 361.184181,
    cy: 35.106746,
    rx: 3.89576826,
    ry: 3.91309524
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.422469,46.0468254 C316.379093,47.125 314.239798,49.643254 313.278992,53.5488095 C312.423275,57.0246032 312.926196,59.9198413 313.278992,61.3674603 L316.776927,61.1488095 C316.581763,60.3873016 316.439144,59.5654762 316.379093,58.6757937 C316.026297,53.4884921 318.721058,49.4246032 320.117229,47.6150794 L317.429975,46.0392857 L317.422469,46.0468254 Z",
    id: "Path",
    fill: "#CADAEE",
    transform: "translate(316.4624, 53.7034) scale(-1, 1) rotate(-180) translate(-316.4624, -53.7034)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.297733,80.6821748 C382.55461,79.2496351 380.79063,76.2413018 377.750579,74.5524129 C375.048312,73.052016 372.646297,73.3083653 371.437783,73.5722541 L371.175063,77.9754287 C371.813098,77.8321748 372.496171,77.756778 373.216776,77.7944764 C377.450327,78.0055875 380.400302,81.8809843 381.683879,83.8563811 L383.290227,80.6897145 L383.297733,80.6821748 Z",
    id: "Path",
    fill: "#83B2BD",
    transform: "translate(377.2364, 78.6135) scale(-1, 1) rotate(-180) translate(-377.2364, -78.6135)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F9DDAC",
    opacity: 0.43,
    transform: "translate(391.8174, 54.7024) scale(-1, 1) rotate(-180) translate(-391.8174, -54.7024)",
    cx: 391.81738,
    cy: 54.702381,
    rx: 5.81738035,
    ry: 5.84325397
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#BFDAE0",
    opacity: 0.46,
    transform: "translate(348.5699, 10.4369) scale(-1, 1) rotate(-180) translate(-348.5699, -10.4369)",
    cx: 348.569874,
    cy: 10.4369048,
    rx: 8.3995466,
    ry: 8.43690476
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 1200,
    height: 110
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgConfetti);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/confetti.ecb7c73b2e6e03cf31e30ac4fef98036.svg";